import { render, staticRenderFns } from "./FinanceProxy.vue?vue&type=template&id=5705957b&scoped=true&"
import script from "./FinanceProxy.vue?vue&type=script&lang=js&"
export * from "./FinanceProxy.vue?vue&type=script&lang=js&"
import style0 from "./FinanceProxy.vue?vue&type=style&index=0&id=5705957b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705957b",
  null
  
)

export default component.exports